import { Instance, SnapshotIn, types } from "mobx-state-tree";
import { withSetPropAction } from "mobx-stores/_extension/with-set-props";
import { Base } from "../base";
import { Customer } from "../customers/customer";
import { Approval } from "./approval";
import { DimensionAndWeight } from "./dimensionandweight";
import { Manufactoring } from "./manufactoring";
import { Material } from "./material";
export const File = types.model({
  name: types.maybeNull(types.string),
  originName: types.maybeNull(types.string),
});
export interface IFile extends Instance<typeof File> {}
export interface IFileProperties extends SnapshotIn<typeof File> {}
export const Product = types
  .compose(
    Base,
    types.model({
      name: types.maybeNull(types.string),
      code: types.maybeNull(types.string),
      barcode: types.maybeNull(types.string),
      unitOfCalculation: types.maybeNull(types.string),
      customerId: types.maybeNull(types.string),
      material: types.maybeNull(Material),
      dimensionWeight: types.maybeNull(DimensionAndWeight),
      customer: types.maybeNull(Customer),
      approval: types.maybeNull(Approval),
      process: types.maybeNull(Manufactoring),
      fileUploads: types.maybeNull(types.array(File)),
      orderNumber: types.maybeNull(types.number),
      isDisabled: types.maybeNull(types.boolean),
    })
  )
  .actions(withSetPropAction);
export interface IProduct extends Instance<typeof Product> {}
export interface IProductProperties extends SnapshotIn<typeof Product> {}
